var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAlbumImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-389 -248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    transform: "translate(389 248)",
    fill: "#fff",
    stroke: "#e3e6e6",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 288,
    height: 288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(435.511 273.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M61.426,113.307A41.378,41.378,0,1,0,19.853,71.93,41.476,41.476,0,0,0,61.426,113.307Z",
    transform: "translate(24.246 99.476)",
    fill: "#cacccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M52.772,15.96H29.016V157.826H52.772Z",
    transform: "translate(74.473 19.491)",
    fill: "#cacccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M78.361,15.96H30.849V51.427H78.361Z",
    transform: "translate(84.519 19.491)",
    fill: "#cacccc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAlbumImage);
export default __webpack_public_path__ + "static/media/defaultAlbumImage.2e729710ccc053e7c43ea21337583290.svg";
export { ForwardRef as ReactComponent };